import { render, staticRenderFns } from "./UserManager.vue?vue&type=template&id=6a3dd034&scoped=true"
import script from "./UserManager.vue?vue&type=script&lang=js"
export * from "./UserManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3dd034",
  null
  
)

export default component.exports